import { Box, Button, Checkbox, Group, Text } from "@mantine/core"
import { useForm } from "@mantine/form"
import React, { useState } from "react"

export interface FormData {
  duplicate: boolean
  is_test: boolean
}

interface Props {
  handleSearchForm: (values: FormData) => Promise<void> | void
}

export const CouponListSearchForm = ({ handleSearchForm }: Props) => {
  const [loading, setLoading] = useState(false)

  const form = useForm<FormData>({
    initialValues: {
      duplicate: false,
      is_test: false,
    },
  })

  return (
    <Box bg="#00000008" p={16} mt={40} bdrs={8}>
      <form method="get" onSubmit={form.onSubmit(async (values) => {
        setLoading(true)
        try {
          await handleSearchForm(values)
        } finally {
          setLoading(false)
        }
      })}>
        <Group gap={24}>
          <Text fz={13} fw={600} c="#000000CC" style={{ width: '100px', textAlign: 'start' }}>CV表示</Text>
          <Group gap={40}>
            <Checkbox
              label="重複CVを除く"
              {...form.getInputProps('duplicate', { type: 'checkbox' })}
            />
            <Checkbox
              label="テストCVを表示"
              {...form.getInputProps('is_test', { type: 'checkbox' })}
            />
          </Group>
        </Group>
        <Group justify="end" mt={16}>
          <Button
            type="submit"
            variant="filled"
            radius="xl"
            fz={13}
            fw={600}
            w={120}
            disabled={loading}
          >
            {loading ? '処理中' : '表示'}
          </Button>
        </Group>
      </form>
    </Box>
  )
}
